/* eslint-disable import/prefer-default-export */
export const withCustomProps = (customProps) => (Comp) =>
  function WithCustomPropsWrapper(props) {
    const cProps = typeof customProps === 'function' ? customProps() : customProps;
    const newProps = { ...props, ...(cProps || {}) };
    return <Comp {...newProps} />;
  };
